<template>
  <div>
    <div :class="modal ? 'd-flex flex-wrap' : 'row'">
      <div class="col-md-12">
        <div class="border p-2">
          <div :class="modal ? 'd-flex flex-wrap' : 'row'">
            <div class="col-12 mb-2" v-if="vabertura">
              <span class="lbl-deal-title">{{ vabertura.caixa }} </span>
              <span v-if="vabertura.aberto" class="badge badge-green">{{ vabertura.status }} </span>
              <span v-if="vabertura.conferido" class="badge badge-gray">{{ vabertura.status }} </span>
              <span v-if="!vabertura.conferido && !vabertura.aberto" class="badge badge-blue">{{ vabertura.status }}
              </span>
            </div>
            <div class="col-4 mb-3">
              <v-label label="Data da Abertura"></v-label> <br>
              <div class="textual" style="font-weight: 600;">{{ vabertura.dataabertura | formatDataHora }}</div>
            </div>
            <div class="col-4 mb-3">
              <v-label label="Operador"></v-label> <br>
              <div class="textual" style="font-weight: 600;">{{ vabertura.operadorabertura }}</div>
            </div>
            <div class="col-4 mb-3">
              <v-label :metadata-field="metadata.vabertura.codfil"></v-label> <br>
              <div class="textual" style="font-weight: 600;">{{ vabertura.filial }}</div>
            </div>
            <div class="col-4 mb-3">
              <v-label label="Valor Fechamento Anterior"></v-label> <br>
              <div class="textual" style="font-weight: 600;">{{ vabertura.valor_ultimo_fechamento | formatValue(2, true)
              }}
              </div>
            </div>
            <div class="col-4 mb-3">
              <v-label label="Valor na Abertura"></v-label> <br>
              <div class="textual" style="font-weight: 600;">{{ vabertura.valorabertura | formatValue(2, true) }}</div>
            </div>
            <div class="col-4 mb-3">
              <v-label label="Total Vendido"></v-label> <br>
              <div class="textual" style="font-weight: 600;">{{ vabertura.vendasValor | formatValue(2, true) }}</div>
            </div>
            <div class="col-4 mb-3">
              <v-label label="Quantidade de Vendas"></v-label> <br>
              <div class="textual" style="font-weight: 600;">{{ vabertura.vendas }}</div>
            </div>
            <div class="col-4 mb-3">
              <v-label label="Valor em Devoluções"></v-label>
              <div class="textual" style="font-weight: 600;">{{ vabertura.devolucoesValor | formatValue(2, true) }}
              </div>
            </div>
            <div class="col-4 mb-3">
              <v-label label="Vendas Canceladas"></v-label> <br>
              <div class="textual" style="font-weight: 600;">{{ vabertura.vendasCanceladas }}</div>
            </div>
          </div>
        </div>
      </div>


      <div class="col-md-12 mt-2">
        <div class="border p-2">
          <div class="row">
            <div class="col-4 mb-3">
              <v-label label="Valor Em Caixa"></v-label> <br>
              <span class="lbl-vcaixa">R$ {{ vabertura.valoremcaixa | formatValue(2, true) }}</span>
            </div>
            <div class="col-4 mb-3">
              <v-label label="Total Saídas"></v-label> <br>
              <span class="lbl-vsaidas">R$ {{ vabertura.valorsaidas | formatValue(2, true) }}</span>
            </div>
            <div class="col-4 mb-3">
              <v-label label="Total Entradas"></v-label> <br>
              <span class="lbl-ventradas">R$ {{ vabertura.valorentradas | formatValue(2, true) }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 mt-2">
        <div class="border p-2">
          <div class="row">
            <div class="col-4 mb-3" v-if="!vabertura.aberto">
              <v-label class="w-100" :metadata-field="metadata.vabertura.dtfechamento"></v-label> <br>
              <div class="textual" style="font-weight: 600;">{{ vabertura.datafechamento | formatDataHora }}</div>
            </div>
            <div class="col-4 mb-3" v-if="!vabertura.aberto">
              <v-label class="w-100" :metadata-field="metadata.vabertura.codusuariof"></v-label> <br>
              <div class="textual" style="font-weight: 600;">{{ vabertura.operadorfechamento }}</div>
            </div>
            <div class="col-4 mb-3">
              <v-label label="Valor de Fechamento"></v-label> <br>
              <form-field v-if="vabertura.aberto" v-model="vabertura.valorfechamento" type="value" :precision="2">
              </form-field>
              <div class="textual" style="font-weight: 600;" v-else>{{ vabertura.valorfechamento | formatValue(2, true)
              }}
              </div>
            </div>
            <div class="col-12">
              <v-label label="Observações"></v-label> <br>
              <form-field v-if="vabertura.aberto" v-model="vabertura.obs" type="memo"></form-field>
              <div class="textual" style="font-weight: 600;" v-else>{{ vabertura.obs }}</div>
            </div>
            <div class="col-12">
              <v-button v-if="vabertura.aberto" :success="true" icon="" label="Fechar Caixa"
                @click="showConfirmAdminPass(handleFechar)"></v-button>
              <v-button v-if="!vabertura.aberto" icon="" label="Rearbrir Caixa"
                @click="showConfirmAdminPass(handleReabrir)"></v-button>
            </div>
            <div class="col-12">
              <!-- MENSAGENS DE VALIDACAO -->
              <validation v-if="errmessages" class="mt-3" title="Erros de Validação" :messages="errmessages">
              </validation>
              <!-- FIM MENSAGENS DE VALIDACAO -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Cofirmação da Senha de administrador -->
    <confirm-adminpass v-if="SHOW_CONFIRMADMINPASS" @close="hideConfirmAdminPass()" @confirm="confirmAdminPass()" />


    <div class="row mt-3">
      <div class="col-md-12 m-2">
        <span class="lbl-deal-title">Formas de Pagamento</span>
      </div>
    </div>

    <div :class="modal ? 'd-flex flex-wrap mb-2' : 'row mb-2'">
      <div class="col-md-12">
        <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
          <div style="overflow: auto">
            <table class="table table-bordered responsive w-100">
              <thead>
                <tr>
                  <th colspan="1" class="text-center">
                    Data
                  </th>
                  <th colspan="1" class="text-center">
                    Descrição
                  </th>
                  <th colspan="1" class="numerico size100">
                    Valor
                  </th>
                  <!-- <th colspan="1" class="numerico size100">
                                        Valor Informado
                                    </th>
                                    <th colspan="1" class="numerico size100">
                                        Diferença
                                    </th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in formasPagamento.lista" :key="index">
                  <td class="textual">{{ row.data | formatData }}</td>
                  <td class="textual">{{ row.descricao }}</td>
                  <td class="numerico size100">{{ row.valor | formatValue(2, true) }}</td>
                  <!-- <td class="numerico size100">{{ row.valorinformado | formatValue(2,true) }}</td>
                                    <td class="numerico size100">{{ row.diferenca | formatValue(2,true) }}</td> -->
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="2" class="text-right total">Total</th>
                  <th class="numerico size100 total"> {{ formasPagamento.total | formatValue(2, true) }} </th>
                  <!-- <th class="numerico size100 total"> {{ formasPagamento.total | formatValue(2,true) }} </th>
                                    <th class="numerico size100 total"> {{ formasPagamento.total | formatValue(2,true) }} </th> -->
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <!-- <div  v-if="chartValues.length > 0" class="col-md-4 p-2">
                <div class="lbl-title mb-2">Gráfico</div>
                <div class="border">
                <chart :params="paramsChart"></chart>
                </div>
            </div> -->
    </div>

    <div class="row" v-if="movimentosCaixa.lista.length">
      <div class="col-md-12 m-2">
        <span class="lbl-deal-title">Movimentos do Caixa</span>
        <a v-if="vabertura.aberto" class="ml-5 btn btn-outline-secondary" href="javascript:void(0)"
          @click="showConfirmAdminPass(handleSangrar)"> <i class="fa fa-minus" aria-hidden="true"></i> <i
            class="fa fa-money" aria-hidden="true"></i> Sangrar </a>
        <a v-if="vabertura.aberto" class="ml-3 btn btn-outline-secondary" href="javascript:void(0)"
          @click="showConfirmAdminPass(handlerReforcar)">
          <i class="fa fa-plus" aria-hidden="true"></i> <i class="fa fa-money" aria-hidden="true"></i> Reforçar </a>
      </div>
    </div>
    <div :class="modal ? 'd-flex flex-wrap mb-2' : 'row mb-2'" v-if="movimentosCaixa.lista.length">
      <div class="col-md-12">
        <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
          <div style="overflow: auto">
            <table class="table table-bordered responsive w-100">
              <thead>
                <tr>
                  <th colspan="1" class="text-center">
                    Data
                  </th>
                  <th colspan="1" class="textual">
                    Descrição
                  </th>
                  <th colspan="1" class="textual">
                    Observações
                  </th>
                  <th colspan="1" class="numerico size100">
                    Valor
                  </th>
                  <th colspan="1" class="textual">

                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in movimentosCaixa.lista" :key="index">
                  <td class="textual">{{ row.data | formatData }}</td>
                  <td class="textual">{{ row.tipo }}</td>
                  <td class="textual">{{ row.observacao }}</td>
                  <td class="numerico size100">{{ row.valoremcaixa | formatValue(2, true) }}</td>
                  <td class="textual"><a href="#" class="alert-link"
                      @click="handleEmissaoCupom(row.codvmovcaixa)">Imprimir</a></td>

                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="3" class="text-right total">Total</th>
                  <th class="numerico size100 total"> {{ movimentosCaixa.total | formatValue(2, true) }} </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="vendasAbertas.lista.length">
      <div class="col-md-12 m-2">
        <span class="lbl-deal-title">Vendas em Espera</span>
      </div>
    </div>
    <div :class="modal ? 'd-flex flex-wrap mb-2' : 'row mb-2'" v-if="vendasAbertas.lista.length">
      <div class="col-md-12">
        <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
          <div style="overflow: auto">
            <table class="table table-bordered responsive w-100">
              <thead>
                <tr>
                  <th colspan="1" class="text-center size100">
                    Pedido
                  </th>
                  <th colspan="1" class="text-center">
                    Data
                  </th>
                  <th colspan="1" class="textual">
                    Observações
                  </th>
                  <th colspan="1" class="numerico size100">
                    Valor
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in vendasAbertas.lista" :key="index">
                  <td class="textual"><a href="#" class="alert-link" @click="handleOpenVendaAberta(row)">{{ row.numero
                  }}</a></td>
                  <td class="textual">{{ row.data | formatData }}</td>
                  <td class="textual">{{ row.obs }}</td>
                  <td class="numerico size100">{{ row.valor | formatValue(2, true) }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="2" class="text-right total">Total</th>
                  <th class="numerico size100 total"> {{ vendasAbertas.total | formatValue(2, true) }} </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>


    <div class="row" v-if="resumoVendas.lista.length">
      <div class="col-md-12 m-2">
        <span class="lbl-deal-title">Resumo das Vendas Por Grupo</span>
      </div>
    </div>
    <div :class="modal ? 'd-flex flex-wrap mb-2' : 'row mb-2'" v-if="resumoVendas.lista.length">
      <div class="col-md-12">
        <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
          <div style="overflow: auto">
            <table class="table table-bordered responsive w-100">
              <thead>
                <tr>
                  <th colspan="1" class="textual">
                    Descrição
                  </th>
                  <th colspan="1" class="numerico size100">
                    Quantidade
                  </th>
                  <th colspan="1" class="numerico size100">
                    Valor
                  </th>
                  <th colspan="1" class="numerico size100">
                    Porcentagem
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in resumoVendas.lista" :key="index">
                  <td class="textual">{{ row.descricao }}</td>
                  <td class="numerico size100">{{ row.qt | formatValue(2, true) }}</td>
                  <td class="numerico size100">{{ row.valor | formatValue(2, true) }}</td>
                  <td class="numerico size100">{{ row.perc | formatValue(2, true) }} %</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <VarejoVmCaixaForm v-if="showVmovCaixaForm" :params="paramsvmovcaixa"
        @resultadovmovcaixa="handleResultadoVmovCaixaForm"></VarejoVmCaixaForm>
    </transition>

    <transition name="fade">
      <VarejoEmissaoCupom v-if="showEmissaoCupomVmov" :index="vmovcaixa.codvmovcaixa" tipo="movimentocaixa"
        @resultadoemissaocupom="handleResultadoEmissaoCupom">
      </VarejoEmissaoCupom>
    </transition>

    <transition name="fade">
      <VarejoEmissaoCupom v-if="showEmissaoCupomFechamento" :index="index" tipo="fechamentocaixa"
        @resultadoemissaocupom="handleResultadoEmissaoCupomFechamento">
      </VarejoEmissaoCupom>
    </transition>


  </div>
</template>

<script>
import Trap from "vue-focus-lock";
import { formatValue } from '../shared/utils'
import { apiORDS, apiORDSpost } from '../shared/api-functions'
import apiPedido from '../api/api-pedido.js'
import VarejoVmCaixaForm from './varejo-vmcaixa-form'
import VarejoEmissaoCupom from "./varejo-emissao-cupom";

export default {

  components: {
    VarejoEmissaoCupom,
    VarejoVmCaixaForm,
    Trap,
  },

  mixins: [apiPedido],
  props: {
    index: '',
    modal: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      errmessages: null,
      vabertura: null,
      formasPagamento: null,
      movimentosCaixa: null,
      vendasAbertas: null,
      resumoVendas: null,
      showVmovCaixaForm: false,
      paramsvmovcaixa: {},
      SHOW_CONFIRMADMINPASS: false,
      params_confirmAdminPass: null,
      valorfechamento_calculado: 0,
      showEmissaoCupomVmov: false,
      showEmissaoCupomFechamento: false,
      vmovcaixa: {},
    }
  },

  computed: {
    idView: function () {
      return !this.vabertura.aberto
    },

    metadata: function () {
      return this.$store.getters.getEntities.metadata
    },

    varejoList() {
      return this.$store.getters.getPedvList;
    }

  },

  watch: {

  },

  filters: {

  },

  methods: {
    handleEmissaoCupom(value) {
      this.vmovcaixa = { codvmovcaixa: value }
      this.showEmissaoCupomVmov = true;
    },
    handleResultadoEmissaoCupom() {
      this.showEmissaoCupomVmov = false;
      this.vmovcaixa = null
    },

    handleEmissaoCupomFechamento() {
      this.showEmissaoCupomFechamento = true;
    },

    handleResultadoEmissaoCupomFechamento() {
      this.showEmissaoCupomFechamento = false;
      this.handleRetorna()
    },


    handleOpenVendaAberta(venda) {
      if (venda && venda.codpedv)
        this.$router.push('/varejo/' + venda.codpedv)
    },
    responseVmovcaixa(vmovcaixa, errmessages, validation) {
      if (validation) {
        this.paramsvmovcaixa.valor = this.vmovcaixa.valor
        this.paramsvmovcaixa.obs = this.vmovcaixa.obs
        this.showVmovCaixaForm = true
        return
      }

      this.errmessages = errmessages;

      if (this.errmessages == null || this.errmessages.length <= 0) {
        this.vmovcaixa = vmovcaixa
        this.showEmissaoCupomVmov = true

      } else {
        for (var x = 0; x < this.errmessages.errmessages.length; x++) {
          this.$erpToastError(this.errmessages.errmessages[x]);
        }
        this.errmessages = {};
      }

      this.loadData()
    },

    async handleResultadoVmovCaixaForm(paramvmovcaixa, result) {
      this.showVmovCaixaForm = false;

      if (result == 'RETORNA') {
        return
      }

      if (result == 'OK') {
        if (paramvmovcaixa) {
          this.vmovcaixa = paramvmovcaixa
          this.vmovcaixa.codvabertura = this.vabertura.codvabertura;
          this.apiVarejoVMovCaixa(this.vmovcaixa, false, this.responseVmovcaixa);
        }
      }
    },

    showConfirmAdminPass(param) {
      this.SHOW_CONFIRMADMINPASS = true;
      this.params_confirmAdminPass = param;
    },

    hideConfirmAdminPass() {
      this.SHOW_CONFIRMADMINPASS = false;
    },

    confirmAdminPass() {
      this.params_confirmAdminPass();
      this.hideConfirmAdminPass();
    },

    handleSangrar() {
      this.handleVmovCaixaForm('S')
    },

    handlerReforcar() {
      this.handleVmovCaixaForm('E')
    },

    handleVmovCaixaForm(valuetpmovcaixa) {
      this.paramsvmovcaixa.tpmovcaixa = valuetpmovcaixa;
      this.paramsvmovcaixa.codvabertura = this.vabertura.codvabertura
      this.paramsvmovcaixa.valor = 0
      this.paramsvmovcaixa.obs = null
      this.showVmovCaixaForm = true;
    },

    handlerSangrar() {
      this.handleVmovCaixaForm('S')
    },

    handlerReforcar() {
      this.handleVmovCaixaForm('E')
    },

    handleRetorna() {
      if (this.$route.path == '/varejo')
        this.$router.push('/varejolist')
      else
        this.$emit('closeform')
    },

    async handleReabrir() {
      let sendData = {
        caixa: {
          id: this.vabertura.codvabertura,
          reabrir: true,
        }
      }
      const data = await apiORDSpost(this.$store, 'varejo/controlecaixa/' + this.index + '/fechar', sendData, 'post')
      this.loadData()
      if (data.errmessages) {
        this.$erpToastError('Erro na reabertura do caixa')
        this.errmessages = data.errmessages
      }
      else
        this.$erpToastSuccess('Caixa Reaberto')
    },

    async handleFechar() {
      let sendData = {
        caixa: {
          id: this.vabertura.codvabertura,
          fechar: true,
          obs: this.vabertura.obs,
          valorfechamento: this.vabertura.valorfechamento,
          formasPagamento: this.formasPagamento.lista
        }
      }
      const data = await apiORDSpost(this.$store, 'varejo/controlecaixa/' + this.index + '/fechar', sendData, 'post')
      if (data.errmessages) {
        this.$erpToastError('Erro no fechamento do caixa')
        this.errmessages = data.errmessages
      }
      else {
        this.$erpToastSuccess('Caixa Fechado')
        this.handleEmissaoCupomFechamento();
      }
    },

    async loadData() {
      const data = await apiORDS(this.$store.getters.urlOrds + 'varejo/controlecaixa/' + this.index, null)
      if (data) {
        this.vabertura = data
        this.resumoVendas = this.vabertura.resumoVendas
        this.formasPagamento = this.vabertura.formasPagamento
        this.movimentosCaixa = this.vabertura.movimentosCaixa
        this.vendasAbertas = this.vabertura.vendasAbertas
      }

      this.valorfechamento_calculado = 0
      //valor para fechamento do caixa deve ser a soma de abertura, reforço, sangria e pagamentos em dinheiro
      //os demais pagamentos não devem somar no valor em caixa
      this.valorfechamento_calculado += this.vabertura.valorEmCaixa
      // if (this.formasPagamento && this.formasPagamento.total) {
      //   this.valorfechamento_calculado += this.formasPagamento.total
      // }
      // if (this.movimentosCaixa && this.movimentosCaixa.total) {
      //   this.valorfechamento_calculado += this.movimentosCaixa.total
      // }

    },

    async loadPedv() {
      const param = {
        query:
          Object.entries(this.query)
            .filter(([_, value]) => value !== null)
            .map(([key, value]) => `${key}=${value}`)
            .join("&") + (this.offset ? `&poffset=${this.nextPage}` : "")
      };
      await this.$store.dispatch("loadPedvList", param);
      this.offset = false;
    },

  },

  created() {
    this.loadData()
    if (this.modal) {
      this.loadPedv()
    }
  },

  mounted() {

    this.$nextTick(function () {
      //const rect = this.$refs.pesquisa.getBoundingClientRect();
      jQuery('[data-toggle="tooltip"]').tooltip()
      //this.$refs.valor.focus()
    })

  }

}

</script>



<style>
table .numerico {
  min-width: 65px;
  text-align: right;
}

table .size100 {
  width: 100px;
}

table .total {
  background: #e7e8e9;
  border: none;
}

table .var-negative {
  color: white;
  background: indianred;
}

table .var-positive {
  color: white;
  background: green;
}

table .border-left {
  border-left: 1px solid #dee2e6;
}

.consulta__total {
  display: flex;
  align-items: center;
  justify-content: center;
}

.consulta__total_valor {
  font-size: 40px;
  display: block;
  line-height: normal;
}

.consulta__cifrao {
  font-size: 16px;
  display: block;
  line-height: normal;
}


.lbl-vcaixa {
  font-size: 120%;
  font-weight: 600;
  color: blue;
}

.lbl-vsaidas {
  font-size: 120%;
  font-weight: 600;
  color: red;
}

.lbl-ventradas {
  font-size: 120%;
  font-weight: 600;
  color: green;
}
</style>






// WEBPACK FOOTER //
// src/forms-varejo/varejo-fecharcaixa-form.vue